export enum ValueState {
  Error = 'Error',
  None = 'None',
  Success = 'Success',
  Warning = 'Warning',
  Information = 'Information'
}
